
import axios from '../plugins/axiosPlugins'
import runEvn from '../modular/runEvn/RunEvn'
const baseURL = runEvn().apiBaseUrl;

/**
 * 获取微信jssdk支付的配置 
 * @returns 
 */
export const payWeJs = (data: any): Promise<any> => {
    return axios.post(`${baseURL}/Pay/WeJs`, data);
}
